import { render, staticRenderFns } from "./CompanyDetailsRelated.vue?vue&type=template&id=4d318f42&"
import script from "./CompanyDetailsRelated.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsRelated.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetailsRelated.vue?vue&type=style&index=0&id=4d318f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports